<template>
    <project-template>

        <project-carousel
        size="100"
        :color="$store.state.activeProject.color"
        :autoplay="true">
          <slide><img v-lazy="'/img/p/packaging/stormchips.jpg'" alt="Storm Chips Packaging"></slide>
          <slide><img v-lazy="'/img/p/packaging/realketones.jpg'" alt="Real Ketones Packaging"></slide>
          <slide><img v-lazy="'/img/p/packaging/sparkle.jpg'" alt="Sparkle Packaging"></slide>
        </project-carousel>

    </project-template>
</template>

<script>
import ProjectTemplate from '../../components/project/ProjectTemplate.vue'
import ProjectCarousel from '../../components/project/ProjectCarousel.vue'
import { Slide } from 'vue-carousel'

export default {
  components: { ProjectTemplate, ProjectCarousel, Slide }
}
</script>

<style lang="scss" scoped>

</style>
